import Marquee from "react-fast-marquee";

const ITEMS = [
  "Laudos Técnicos", "SPDA", "Iluminação LED", "Termografia", "Quadros de Comando",
  "Veículos Elétricos", "Manutenção Predial", "Eficiência Energética", "Centro de Medição",
];

export default function ServiceMarquee() {
  return (
    <div data-testid="marquee" className="border-y border-white/10 bg-surface py-6 overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white/90 px-8">
              {t}
            </span>
            <span className="text-coral text-3xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
